import { MerchCardLayoutUI } from '../../../components/MerchCardLayoutUI';
import DetailedTermSelector from '../../../components/merch-card/terms-display/DetailedTermSelector';
import RequiredOnboardingSubtextContainer from '../../../components/required-onboarding/RequiredOnboardingSubtextContainer';
import { createMerchCardTrackingData } from '../../../utils/trackingData';
import { PurchaseMotionContainer } from '../../PurchaseMotionContainer';
import { IncludedHubSpotCreditsContainer } from '../credits-display/IncludedHubSpotCreditsContainer';
import { MerchCardSubheadingContainer } from '../headings-display/MerchCardSubheadingContainer';
import { MerchCardPrice } from '../price-display/MerchCardPrice';
import { IncludedSeatsDisplayContainer } from '../seats-display/IncludedSeatsDisplayContainer';
import { useShowPricePerMonthPerSeat } from '../seats-display/useSeatsDisplay';
import { SubtextDisplayContainer } from '../subtext-display/SubtextDisplayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubMerchCard = ({
  apiName,
  Title,
  Features,
  columnStart = 1,
  Subheading,
  screen,
  skipInterstitial = false,
  hideRequiredOnboarding = false
}) => {
  const {
    showPricePerMonthPerSeat
  } = useShowPricePerMonthPerSeat({
    productApiName: apiName
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `${apiName}-merch-card`,
    "data-selenium-id": `${apiName}-merch-card`,
    columnStart: columnStart,
    Title: Title,
    Subheading: /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
      Subheading: Subheading,
      apiName: apiName
    }),
    Pricing: /*#__PURE__*/_jsx(MerchCardPrice, {
      productApiName: apiName,
      showPerMonthPerSeat: showPricePerMonthPerSeat
    }),
    Seats: /*#__PURE__*/_jsx(IncludedSeatsDisplayContainer, {
      productApiName: apiName
    }),
    Credits: /*#__PURE__*/_jsx(IncludedHubSpotCreditsContainer, {
      productApiName: apiName
    }),
    Subtext: /*#__PURE__*/_jsx(SubtextDisplayContainer, {
      productApiName: apiName
    }),
    Term: /*#__PURE__*/_jsx(DetailedTermSelector, {
      apiName: apiName,
      trackingSource: 'merch-card'
    }),
    CTAs: /*#__PURE__*/_jsx(PurchaseMotionContainer, {
      productApiName: apiName,
      location: "MERCH_CARD",
      trackingData: createMerchCardTrackingData(apiName, screen),
      skipInterstitial: skipInterstitial
    }),
    Features: Features,
    Footer: hideRequiredOnboarding ? null : /*#__PURE__*/_jsx(RequiredOnboardingSubtextContainer, {
      productApiNames: [apiName]
    })
  });
};